import clsx from "clsx"
import NavEngrave from "@/assets/imgs/nav-engrave.png"

const EngraveTitle = ({ title, subTitle = "", custCls, isSmaller = false }) => {
  return (
    <>
      {isSmaller ?
        <div className="mb-8">
          <h2 className="font-agcasmlt text-md sm:text-lg md:text-xl lg:text-2xl font-semibold text-[#95702e] text-center mb-3">
            {title}
            <span className="block">{subTitle}</span></h2>
          <img img="100" src={NavEngrave} className="w-28 -mt-1 mx-auto" />
        </div>
        :
        <div className={clsx("mb-14 pt-24", custCls)}>
          <h2 className="font-agcasmlt capitalize text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-[#6d625a] text-center mb-3">{title}</h2>
          <img img="100" src={NavEngrave} className="w-20 -mt-1 mx-auto" />
        </div>
      }
    </>
  )
}

export default EngraveTitle